import CryptoJS from 'crypto-js';

// Chave fixa para criptografia (não precisa de configuração externa)
const SECRET_KEY = 'jdw2025@danieleleao#dev';

export const encryptData = (data: Record<string, any>): string => {
  try {
    const jsonString = JSON.stringify(data);
    const encrypted = CryptoJS.AES.encrypt(jsonString, SECRET_KEY).toString();
    return encodeURIComponent(encrypted);
  } catch (error) {
    console.error('Error encrypting data:', error);
    throw new Error('Failed to encrypt data');
  }
};

export const decryptData = (encryptedString: string): Record<string, any> => {
  try {
    const decoded = decodeURIComponent(encryptedString);
    const decrypted = CryptoJS.AES.decrypt(decoded, SECRET_KEY).toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  } catch (error) {
    console.error('Error decrypting data:', error);
    throw new Error('Failed to decrypt data');
  }
}; 